export const CLEAR_FARMS = 'clear-farms';
export const FARMS_REQUEST = "farms-request";
export const FARMS_REQUEST_SUCCESS = "farms-request-success";
export const FARMS_REQUEST_ERROR = "farms-request-error";

export const CREATE_FARMS_REQUEST = 'create-farms-request';
export const CREATE_FARMS_SUCCESS = "create-farms-success";
export const CREATE_FARMS_FAILURE = "create-farms-failure";

export const FARM_DELETE = "farm-delete";
export const FARM_DELETE_SUCCESS = "farm-delete-success";
export const FARM_DELETE_ERROR  = "farm-delete-error";

export const FARM_LIST_CLEAR = 'farm-list:clear';
export const FARM_LIST_REQUEST = "farm-list:request";
export const FARM_LIST_SUCCESS = "farm-list:success";
export const FARM_LIST_ERROR = "farm-list:error";

export const FARM_LIST_FILTER_PERSIST = "farm-list-filter:persist";
export const FARM_LIST_FILTER_CLEAR = "farm-list-filter:clear";
